import { useState } from 'react';
import {
  Button,
  Country,
  Flex,
  Header,
  OneColumnLayout,
  Text,
} from '@electricjs/arc';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import CountrySelector from '@/components/AddressValidation/CountrySelector/CountrySelector';

type DeviceLocationConfirmationProps = {
  onNext: (country: Country) => void;
  // Pre-selects the country on the dropdown so navigating back to this step
  // doesn't lose a previous selection (this component remounts per step).
  defaultCountry?: Country;
};

const DeviceLocationConfirmation = ({
  onNext,
  defaultCountry,
}: DeviceLocationConfirmationProps) => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();
  const [selectedCountry, setSelectedCountry] = useState<Country | ''>(
    defaultCountry ?? ''
  );

  return (
    <OneColumnLayout>
      <Header title={t('offboardings.locationConfirmation.title')} />
      <Text mt="2rem">{t('offboardings.locationConfirmation.body')}</Text>
      <Flex mt="2rem" maxWidth="40rem">
        <CountrySelector
          name="employeeLocationCountry"
          control={control}
          value={selectedCountry}
          onChange={value => setSelectedCountry(value as Country)}
          required
        />
      </Flex>
      <Flex mt="2rem" hAlignContent="right">
        <Button
          id="location-confirmation-next-button"
          disabled={!selectedCountry}
          onClick={() => {
            if (selectedCountry) {
              onNext(selectedCountry);
            }
          }}>
          {t('offboardings.locationConfirmation.nextButton')}
        </Button>
      </Flex>
    </OneColumnLayout>
  );
};

export default DeviceLocationConfirmation;
